import { render, staticRenderFns } from "./CVProfileBanner.vue?vue&type=template&id=da36b272"
import script from "./CVProfileBanner.vue?vue&type=script&lang=js"
export * from "./CVProfileBanner.vue?vue&type=script&lang=js"
import style0 from "./CVProfileBanner.vue?vue&type=style&index=0&id=da36b272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports